import { ButtonHTMLAttributes, HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import Spinner from '~components/Spinner';

import { getLoadingVariant } from './helper';
import * as S from './style';

export type Size = 'lg' | 'md' | 'sm';
export type Variant = 'magenta' | 'dark' | 'light';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  leading?: ReactNode | string;
  trailing?: ReactNode | string;
  disabled?: boolean;
  inlineCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  as?: 'a' | 'button';
  target?: HTMLAttributeAnchorTarget;
  href?: string;
  loading?: boolean;
}

export default function Button({
  children,
  variant = 'dark',
  size = 'lg',
  as = 'button',
  target,
  href,
  leading,
  trailing,
  disabled,
  inlineCss,
  loading,
  ...props
}: ButtonProps) {
  return (
    <S.Button
      variant={variant}
      size={size}
      disabled={disabled || loading}
      inlineCss={inlineCss}
      as={as}
      target={target}
      href={href}
      loading={loading}
      {...props}>
      <S.ButtonInner $loading={loading}>
        {leading}
        {children}
        {trailing}
      </S.ButtonInner>
      {loading && (
        <S.LoadingWrapper>
          <Spinner variant={getLoadingVariant(variant)} width={36} height={36} />
        </S.LoadingWrapper>
      )}
    </S.Button>
  );
}
